/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

export const PageError = ({ error }) =>
  error && (
    <div>
      ERROR: {error.message} <br />
      STACK: {error.stack}
    </div>
  );
PageError.propTypes = {
  error: PropTypes.any,
};
PageError.defaultProps = {
  error: null,
};
